'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '& .rc-select': {
    boxSizing: 'border-box',
    display: 'inline-block',
    position: 'relative',
    verticalAlign: 'middle',
    color: '#666',
    lineHeight: '36px',
    width: '100%'
  },
  '& .rc-select-allow-clear .rc-select-selection--single .rc-select-selection__rendered': {
    paddingRight: '40px'
  },
  '& .rc-select ul, .rc-select li': {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  '& .rc-select > ul > li > a': {
    padding: 0,
    backgroundColor: '#fff'
  },
  '& .rc-select-arrow': {
    height: '26px',
    position: 'absolute',
    top: '1px',
    right: '1px',
    width: '20px',
    outline: 'none'
  },
  '& .rc-select-arrow b:before': {
    content: '"\\f107"', // fa-angle-down
    fontFamily: 'FontAwesome',
    marginLeft: '-4px',
    marginTop: '-2px',
    position: 'absolute'
  },
  '& .rc-select-open .rc-select-arrow b:before': {
    display: 'none'
  },
  '& .rc-select-arrow b:after': {
    display: 'none'
  },
  '& .rc-select-open .rc-select-arrow b:after': {
    content: '"\\f106"', // fa-angle-up
    fontFamily: 'FontAwesome',
    marginLeft: '-4px',
    marginTop: '-2px',
    position: 'absolute',
    opacity: 1,
    display: 'block'
  },
  '& .rc-select-selection': {
    outline: 'none',
    MozUserSelect: 'none',
    MsUserSelect: 'none',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    boxSizing: 'border-box',
    display: 'block',
    backgroundColor: '#fff',
    border: '1px solid #d9d9d9'
  },
  '& .rc-select-selection__placeholder': {
    position: 'absolute',
    top: 0,
    color: '#aaa'
  },
  '& .rc-select-selection__clear': {
    fontWeight: 'bold',
    position: 'absolute',
    lineHeight: '36px'
  },
  '& .rc-select-selection__clear:after': {
    content: '"×"'
  },
  // Custom onClear
  '& .children': {
    position: 'relative'
  },
  '& .clear-value': {
    top: 0,
    right: '35px',
    cursor: 'pointer',
    color: '#666'
  },
  '& .multiselect + .clear-value': {
    right: '8px'
  },
  '& .rc-select-selection--single': {
    height: '36px',
    lineHeight: '36px',
    cursor: 'pointer',
    position: 'relative'
  },
  '& .rc-select-selection--single .rc-select-selection-selected-value': {
    position: 'absolute',
    left: 0,
    top: 0
  },
  '& .rc-select-selection--single .rc-select-selection__rendered': {
    height: '36px',
    position: 'relative',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: '10px',
    paddingRight: '20px',
    lineHeight: '36px'
  },
  '& .rc-select-selection--single .rc-select-selection__clear': {
    top: 0,
    right: '35px'
  },
  '& .rc-select-disabled': {
    color: '#ccc',
    cursor: 'not-allowed'
  },
  '& .rc-select-disabled .rc-select-selection--single, .rc-select-disabled .rc-select-selection__choice__remove': {
    cursor: 'not-allowed',
    color: '#ccc'
  },
  '& .rc-select-disabled .rc-select-selection--single:hover, .rc-select-disabled .rc-select-selection__choice__remove:hover': {
    cursor: 'not-allowed',
    color: '#ccc'
  },
  '& .rc-select-search__field__wrap': {
    display: 'inline-block'
  },
  '& .rc-select-search__field__placeholder': {
    position: 'absolute',
    top: 0,
    left: '3px',
    color: '#aaa'
  },
  '& .rc-select-search--inline': {
    width: '100%'
  },
  '& .rc-select-search--inline .rc-select-search__field__wrap': {
    width: '100%'
  },
  '& .rc-select-search--inline .rc-select-search__field': {
    border: 'none',
    fontSize: '100%',
    background: 'transparent',
    outline: 0,
    width: '100%'
  },
  '& .rc-select-search--inline .rc-select-search__field::-ms-clear': {
    display: 'none'
  },
  '& .rc-select-search--inline .rc-select-search__field__mirror': {
    position: 'absolute',
    top: '-999px',
    left: 0,
    whiteSpace: 'pre'
  },
  '& .rc-select-search--inline > i': {
    float: 'right'
  },
  '& .rc-select-enabled.rc-select-selection--multiple': {
    cursor: 'text'
  },
  '& .rc-select-selection--multiple': {
    minHeight: '36px'
  },
  '& .rc-select-selection--multiple .rc-select-search--inline': {
    float: 'left',
    width: 'auto'
  },
  '& .rc-select-selection--multiple .rc-select-search--inline .rc-select-search__field': {
    width: '0.75em'
  },
  '& .rc-select-selection--multiple .rc-select-search--inline .rc-select-search__field__wrap': {
    width: 'auto'
  },
  '& .rc-select-selection--multiple .rc-select-search__field__placeholder': {
    top: '5px',
    left: '8px'
  },
  '& .rc-select-selection--multiple .rc-select-selection__rendered': {
    position: 'relative',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginLeft: '8px',
    paddingBottom: '2px'
  },
  '& .rc-select-selection--multiple .rc-select-selection__rendered .rc-select-selection__choice': {
    marginTop: '4px',
    lineHeight: '30px'
  },
  '& .rc-select-selection--multiple .rc-select-selection__clear': {
    top: '1px',
    right: '8px'
  },
  '& .rc-select-enabled .rc-select-selection__choice': {
    cursor: 'default'
  },
  '& .rc-select-enabled .rc-select-selection__choice:hover .rc-select-selection__choice__remove': {
    opacity: 1,
    transform: 'scale(1)'
  },
  // '& .rc-select-enabled .rc-select-selection__choice:hover .rc-select-selection__choice__content': {
  //   marginLeft: '-8px',
  //   marginRight: '8px',
  // },
  '& .rc-select-enabled .rc-select-selection__choice__disabled': {
    cursor: 'not-allowed'
  },
  '& .rc-select-enabled .rc-select-selection__choice__disabled:hover .rc-select-selection__choice__content': {
    marginLeft: 0,
    marginRight: 0
  },
  '& .rc-select .rc-select-selection__choice': {
    backgroundColor: '#f3f3f3',
    float: 'left',
    padding: '0 30px 0 15px',
    marginRight: '4px',
    position: 'relative',
    overflow: 'hidden',
    transition: 'padding 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045), width 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045)'
  },
  '& .rc-select .rc-select-selection__choice__content': {
    marginLeft: 0,
    marginRight: 0
  },
  '& .rc-select .rc-select-selection__choice__remove': {
    color: '#919191',
    cursor: 'pointer',
    fontWeight: 'bold',
    padding: '0 0 0 8px',
    position: 'absolute',
    opacity: 1,
    top: 0,
    right: '10px'
  },
  '& .rc-select .rc-select-selection__choice__remove:before': {
    content: '"×"'
  },
  '& .rc-select .rc-select-selection__choice__remove:hover': {
    color: '#333'
  },
  '&.rc-select-dropdown': {
    backgroundColor: 'white',
    border: '1px solid #d9d9d9',
    boxShadow: '0 0px 4px #d9d9d9',
    boxSizing: 'border-box',
    zIndex: 100,
    left: '-9999px',
    top: '-9999px',
    position: 'absolute',
    outline: 'none',
    maxHeight: '288px',
    overflow: 'auto'
  },
  '&.rc-select-dropdown:empty, &.rc-select-dropdown-hidden': {
    display: 'none'
  },
  '& .rc-select-dropdown-menu': {
    outline: 'none',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    zIndex: 200
  },
  '&.rc-select-dropdown.rc-select-dropdown-placement-bottomLeft': {
    borderTop: 'none'
  },
  '&.rc-select-dropdown.rc-select-dropdown-placement-topLeft': {
    borderBottom: 'none'
  },
  '& .rc-select-dropdown-menu > li': {
    margin: 0,
    padding: 0,
    borderBottom: '1px solid black'
  },
  '& .rc-select-dropdown-menu > li:last-child': {
    borderBottom: 'none'
  },
  '& .rc-select-dropdown-menu-item-group-list': {
    margin: 0,
    padding: 0
  },
  '& .rc-select-dropdown-menu-item-group-list > li.rc-select-menu-item': {
    paddingLeft: '20px'
  },
  '& .rc-select-dropdown-menu-item-group-title': {
    color: '#999',
    lineHeight: 1.5,
    padding: '8px 10px',
    borderBottom: '1px solid #dedede'
  },
  '& li.rc-select-dropdown-menu-item': {
    margin: 0,
    height: '36px',
    position: 'relative',
    display: 'block',
    lineHeight: '36px',
    padding: '0 10px',
    fontWeight: 'normal',
    color: '#666',
    whiteSpace: 'nowrap'
  },
  '& li.rc-select-dropdown-menu-item-disabled': {
    color: '#ccc',
    cursor: 'not-allowed'
  },
  '& li.rc-select-dropdown-menu-item-selected': {
    color: '#666',
    backgroundColor: '#ddd'
  },
  '& li.rc-select-dropdown-menu-item-active': {
    backgroundColor: '#5897fb',
    color: 'white',
    cursor: 'pointer'
  },
  '& li.rc-select-dropdown-menu-item-divider': {
    height: '1px',
    margin: '1px 0',
    overflow: 'hidden',
    backgroundColor: '#e5e5e5',
    lineHeight: 0
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Select/Base.styles.js
// module id = 241
// module chunks = 0